import { AxiosResponse } from "axios";
import { IPaymentTerms, IStateCart } from "@/apps/merchant3/models/IStateCart";
import {
  IPreRegDevices,
  IPreRegPaymentTerm,
} from "@/apps/merchant3/models/IStateOffers";
import logEvent from "@/apps/merchant3/services/event-logs.service";
import { isEcommerceFlow } from "@/apps/merchant3/helpers/checkoutFlows";

type BasicTypes = string | number | boolean | null | undefined;
type AcceptedValues =
  | IPaymentTerms
  | BasicTypes
  | IPreRegDevices
  | IStateCart
  | IPreRegPaymentTerm;

export const logEcommerceEvent = async (
  name: string,
  data?: Record<string, AcceptedValues> | BasicTypes
): Promise<AxiosResponse<unknown> | false> => {
  if (isEcommerceFlow.value) {
    return logEvent(name, data);
  }
  return false;
};
